"use client"
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useLenis } from "lenis/react";
import { useEffect, useRef } from "react";
import Cta from "@/components/cta/cta";
import Close from "@/components/icon/close";

export default function OverlayWrapper({
  children,
  isOpen,
  setIsOpen,
  isLinkClicked,
  setIsLinkClicked
}) {
  const lenis = useLenis();
  const wrapperRef = useRef(null);
  const bgRef = useRef(null);


  useEffect(() => {
    if (isOpen) {
      lenis?.stop();
    } else {
      lenis?.start();
    }

    return () => lenis?.start();
  }, [isOpen, lenis]);

  const animateIn = () => {
    gsap.to(bgRef.current, {
      opacity: 0.5,
      duration: 1
    })

    gsap.to(wrapperRef.current, {
      opacity: 1,
      duration: 0.4,
      ease: 'linear.none'
    })

    // gsap.fromTo(wrapperRef.current, {
    //   transformOrigin: '90% 10%'
    // }, {
    //   y: 0,
    //   rotate: 0,
    //   duration: 1,
    //   ease: 'expo.out'
    // })
  }

  const animateOut = (cb) => {
    // gsap.to(wrapperRef.current, {
    //   y: 0.5 * window.innerHeight,
    //   rotate: -5,
    //   duration: 0.5,
    //   ease: 'expo.out',
    //   onComplete: cb
    // })

    gsap.to(bgRef.current, {
      opacity: 0,
      duration: 0.35,
      onComplete: cb
    })

    gsap.to(wrapperRef.current, {
      opacity: 0,
      duration: 0.2,
      ease: 'linear.none'
    })
  }

  const isAnimatingOut = useRef(false);

  const onClose = () => {
    if (isAnimatingOut.current) {
      return
    }

    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: reduce)", () => {
      setIsOpen(false)
    });

    mm.add("(prefers-reduced-motion: no-preference)", () => {
      isAnimatingOut.current = true
      animateOut(() => setIsOpen(false))
    });
  }

  useGSAP(() => {
    if (isOpen && wrapperRef.current) {
      isAnimatingOut.current = false;
      const mm = gsap.matchMedia();

      mm.add("(prefers-reduced-motion: reduce)", () => {
        gsap.set(wrapperRef.current, {
          opacity: 1,
        })
      });
  
      mm.add("(prefers-reduced-motion: no-preference)", () => {
        animateIn()
      });
    }
  }, [isOpen, wrapperRef])

  useEffect(() => {
    if (isLinkClicked) {
      onClose();
      setIsLinkClicked(false)
    }
  }, [isLinkClicked])

  const closeBtn = useRef(null)

  useEffect(() => {
    if (isOpen && closeBtn.current) {
      closeBtn.current?.focus();
    }
  }, [isOpen, closeBtn])

  if (isOpen) {
    return (
      <div className="w-screen full-height-screen fixed top-0 left-0 z-3000">
        <div className="w-full h-full absolute top-0 left-0 bg-black opacity-0" ref={bgRef}/>
        <div className="w-full h-full opacity-0" ref={wrapperRef}>
          <Cta 
            ref={closeBtn}
            className='absolute z-50 top-[calc(2.5rem)] right-6 cta-light cta-icon-stroke-theme cta-circle-small pointer-events-auto lg:fixed lg:top-[calc(var(--space-8))] lg:right-(--space-8) lg:cta-circle'
            onClick={onClose}><Close /></Cta>
          {children}
        </div>
      </div>
    )
  }

  return (<></>)
}
